import Component from '../app/component'
import { animate } from 'motion'

export default class MobileMenuComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      display: false
    }
  }

  init () {
    document.addEventListener('mobilemenu.toggle', () => this.toggle())
    if (this.refs.close) {
      this.refs.close.addEventListener('pointerdown', () => this.toggle())
    }

    if (this.refs?.primaryLabels) {
      this.refs.primaryLabels.forEach((el) => {
        el.addEventListener('pointerup', () => {
          this.toggleNav(el.parentNode.querySelector('.mobilemenu-nav-items'))
        })
      })
    }
  }

  toggle() {
    this.data.display = !this.data.display
  }

  toggleNav(el) {
    if (!el) {
      return
    }
    let height = el.offsetHeight
    if (height === 0) {
      el.style.height = 'auto'
      el.parentNode.classList.add('mobilemenu-section--active')
      height = el.offsetHeight
      el.style.height = null

      this.animation = animate(
        el,
        {
          paddingTop: '3rem',
          height: [null, `${height}px`]
        },
        {
          duration: 0.5,
          easing: 'cubic-bezier(.39,.76,.12,1)'
        }
      )
    }
    else {
      el.parentNode.classList.remove('mobilemenu-section--active')
      this.animation = animate(
        el,
        {
          paddingTop: 0,
          height: 0
        },
        {
          duration: 0.25,
          easing: 'cubic-bezier(.39,.76,.12,1)'
        }
      )
    }
  }

  watchDisplay(value) {
    if (value) {
      document.body.classList.add('layout-unscrollable')
      this.el.classList.add(this.el.dataset.activeClass)
    }
    else {
      document.body.classList.remove('layout-unscrollable')
      this.el.classList.remove(this.el.dataset.activeClass)
    }
  }
}
